import React, { useEffect, useState } from "react";
import IconEdit from "../../../components/icons/IconEdit";
import IconTrash from "../../../components/icons/IconTrash";

import EditarParametros from "./EditarParametros";
import VerParametro from "./VerParametro";
import FiltroParametros from "./FiltroParametros";
import CrearParametro from "./CrearParametro";
import EliminarParametro from "./EliminarParametro";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
// IMPORTANTE: Importamos DynamicTable
import DynamicTable from "../../../components/listing/DynamicTable";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

// Normalizar fecha, invalidDate
function parseFechaParametro(valor) {
  if (!valor) return "";

  // Ej: "17-dic-2025 00:00:00"
  const parte = valor.split(" ")[0]; // "17-dic-2025"
  const [dia, mesTxt, anio] = parte.split("-");

  const meses = {
    ene: "01", feb: "02", mar: "03", abr: "04", may: "05", jun: "06",
    jul: "07", ago: "08", sep: "09", oct: "10", nov: "11", dic: "12",
  };

  const mes = meses[mesTxt?.toLowerCase()];
  if (!mes) return "";

  return new Date(`${anio}-${mes}-${dia}T00:00:00`);
}

export default function DatosParametros() {
  // ================================
  //   PAGINACIÓN & ESTADO
  // ================================
  const [pagina, setPagina] = useState(1);
  const [porPagina, setPorPagina] = useState(10);
  const [reloadKey, setReloadKey] = useState(0);

  const [items, setItems] = useState([]);
  const [totalElements, setTotalElements] = useState(0);

  // ===== Estados de modales =====
  const [showEditar, setShowEditar] = useState(false);
  const [showEliminar, setShowEliminar] = useState(false);
  const [showVer, setShowVer] = useState(false);
  const [showFiltros, setShowFiltros] = useState(false);
  const [showCrear, setShowCrear] = useState(false);

  const [selected, setSelected] = useState(null);

  // ===== Estado de filtros =====
  const [filtros, setFiltros] = useState({
    nombre: "",
    valor: "",
    fecha: "",
    numero: "",
    prioridad: "",
  });

  // ================================
  //   CARGA DE DATOS
  // ================================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = apiRoutes.parametros.listUrl({
          page: pagina - 1,
          size: porPagina,
          ...filtros,
        });

        const resp = await appFetchJson(url);

      setItems(
  (resp.items || []).map((it) => ({
    id: it.id,
    nombre: it.nombre,
    valor: it.valor,
    fecha: it.fecha,           // ← fecha cruda de la API
    numero: it.numero,
    prioridad: it.prioridad,
  })),
);

        setTotalElements(resp.totalElements ?? 0);
      } catch (err) {
        console.error("Error cargando parámetros:", err);
      }
    };

    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  // ====================================================================
  // DEFINICIÓN DE COLUMNAS (TOTAL 100%)
  // ====================================================================
  const columns = [
    // 1. NOMBRE (25%)
    { 
      header: "Nombre", 
      accessor: "nombre",
      type: "text", 
      width: "25%", 
      cellClass: "font-medium text-gray-800 break-words" 
    },
    // 2. VALOR (25%)
    { 
      header: "Valor", 
      accessor: "valor",
      type: "text", 
      width: "25%", 
      cellClass: "text-gray-600 break-all" // break-all por si es un string muy largo sin espacios
    },
    // 3. FECHA (15%)
    { 
  header: "Fecha", 
  accessor: "fecha",
  type: "center", 
  width: "15%",
  render: (row) => {
    const d = parseFechaParametro(row.fecha);
    return d ? d.toLocaleDateString() : "—";
  }
},
    // 4. NÚMERO (10%)
    { 
      header: "Número", 
      accessor: "numero",
      type: "center", // O 'text-right'
      width: "10%",
      render: (row) => row.numero || "—"
    },
    // 5. PRIORIDAD (10%)
    { 
      header: "Prioridad", 
      accessor: "prioridad",
      type: "center", 
      width: "10%",
      render: (row) => row.prioridad || "—"
    },
    // 6. ACCIÓN (15%)
    {
      header: "Acción",
      type: "action", 
      width: "15%",
      render: (it) => (
        <div className="flex justify-center items-center gap-2">
          <button
            title="Editar"
            onClick={() => {
              setSelected(it);
              setShowEditar(true);
            }}
          >
            <IconEdit/>
          </button>

          <button
            title="Eliminar"
            onClick={() => {
              setSelected(it);
              setShowEliminar(true);
            }}
          >
            <IconTrash/>
          </button>

        </div>
      )
    }
  ];

  // ==============================
  //    RENDER PRINCIPAL
  // ==============================
  return (
    <div className="page">

      <ListHeader
        title="Parámetros Generales"
        onFilterClick={() => setShowFiltros(true)}
        filters={filtros}
        onClearFilters={() => {
          setFiltros({
            nombre: "",
            valor: "",
            fecha: "",
            numero: "",
            prioridad: "",
          });
          setPagina(1);
        }}
        showAdd
        addLabel="Agregar"
        onAddClick={() => setShowCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
        pageSizeOptions={[10, 20, 30]}
      />

      {/* === MODAL DE CREAR PARAMETRO === */}
      {showCrear && (
        <CrearParametro
          onClose={() => setShowCrear(false)}
          onCreated={() => {
            setPagina(1); 
            setReloadKey((k) => k + 1); 
            setShowCrear(false);
          }}
        />
      )}

      {/* ===== Panel Filtros ===== */}
      {showFiltros && (
        <FiltroParametros
          initialFilters={filtros}
          onClose={() => setShowFiltros(false)}
          onSubmit={(f) => {
            setPagina(1); 
            setFiltros(f); 
            setShowFiltros(false);
          }}
        />
      )}

      {/* ===== TABLA DINÁMICA === */}
      <DynamicTable 
        size="M" // 6 Columnas -> Breakpoint 1024px
        data={items}
        columns={columns}
      />

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalElements}
        onPageChange={(p) => setPagina(p)}
      />

      {/* ===== MODAL VER ===== */}
      {showVer && selected && (
        <VerParametro data={selected} onClose={() => setShowVer(false)} />
      )}

      {/* ===== MODAL EDITAR ===== */}
      {showEditar && selected && (
        <EditarParametros
          initial={selected}
          onClose={() => {
            setShowEditar(false);
            setSelected(null);
          }}
          onSaved={(updated) => {
            // Actualización optimista local
            setItems((prev) =>
              prev.map((it) => (it.id === updated.id ? { ...it, ...updated } : it)),
            );
            // Opcional: forzar recarga real
            setReloadKey((k) => k + 1);
          }}
        />
      )}

      {/* ===== MODAL ELIMINAR ===== */}
      {showEliminar && selected && (
        <div className="modal-backdrop" onClick={() => setShowEliminar(false)}>
          <div
            className="modal-panel-md" // Cambiado a md para consistencia
            onClick={(e) => e.stopPropagation()}
          >
            <EliminarParametro
              registro={selected}
              onClose={() => setShowEliminar(false)}
              onDeleted={() => {
                setReloadKey((k) => k + 1);
                setShowEliminar(false);
                setSelected(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}